import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import PublicMap from '../components/PublicMap/PublicMap';

const PublicMapBridge = react2angular(PublicMap, ['processMapId']);

export default PublicMapBridge;
